export default function Logo({ size = 32, withWordmark = true, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="app-logo">
      <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="6" fill="#00A8FF" opacity="0.1" />
        <rect x="0.5" y="0.5" width="63" height="63" rx="5.5" fill="none" stroke="#00A8FF" strokeOpacity="0.35" />
        <path d="M14 16h22c7.18 0 13 5.82 13 13s-5.82 13-13 13H14V16z" fill="none" stroke="#00A8FF" strokeWidth="4" />
        <path d="M14 29h18" stroke="#00A8FF" strokeWidth="4" />
        <circle cx="47" cy="46" r="3" fill="#00A8FF" />
      </svg>
      {withWordmark && (
        <div className="leading-none">
          <div className="text-sm font-semibold tracking-[0.12em] text-white">B2BPROBLEMSOLVER</div>
          <div className="text-[10px] font-mono tracking-[0.25em] text-primary mt-0.5">COMMAND · CENTER</div>
        </div>
      )}
    </div>
  );
}
